import { Box, Flex, Text } from "rebass/styled-components";
import styled, { css } from "styled-components";
import { useRecoilValue } from "recoil";

import { Moment } from "../Moment";
import { TimePill } from "../styledComponents";
import { TMoment } from "MVVM/Views/MatchHistory/@types";
import { MomentsViewModel } from "./ViewModel";
import { MomentsLoading } from "../../MatchesTableLoading";
import { NoMoments } from "../NoMoments";
import { MatchHistoryWidgetSourceState } from "MVVM/State/matchHistory";

const MomentsList = ({
  matchId,
  isWidget,
  outdated,
}: {
  matchId: string;
  isWidget?: boolean;
  outdated: boolean;
}) => {
  const limit = isWidget ? 3 : 20;
  const widgetSource = useRecoilValue(MatchHistoryWidgetSourceState);
  const { moments, loading, requestOnDemandMoments } = MomentsViewModel(
    matchId,
    limit,
  );

  return (
    <>
      {loading && <MomentsLoading />}
      {!loading && !moments.length && (
        <NoMoments requestOnDemandMoments={requestOnDemandMoments} />
      )}
      {!loading &&
        !!moments.length &&
        moments.map((moment: TMoment) => (
          <MomentContainer key={moment.id} $widgetSource={widgetSource}>
            <Timeline mr="4" className="timeline">
              <TimePill>
                <Text fontSize="0" style={{ minWidth: "auto" }}>
                  {moment.timelineLabel}
                </Text>
              </TimePill>
            </Timeline>
            <Moment
              moment={moment}
              isWidget={isWidget}
              outdated={outdated}
              matchId={matchId}
            />
          </MomentContainer>
        ))}
    </>
  );
};

const MomentContainer = styled(Flex)<{ $widgetSource: string }>`
  :nth-child(2) :first-child.timeline {
    margin-top: 28px;
    padding: 0;
  }

  :last-child :first-child.timeline {
    height: 0;
  }

  ${({ $widgetSource }) =>
    $widgetSource === "iframe" &&
    css`
      @media (max-height: 585px), (max-width: 650px) {
        :last-child {
          display: none;
        }
      }

      @media (max-height: 500px), (max-width: 500px) {
        :nth-last-child(2) {
          display: none;
        }
      }
    `}
`;

const Timeline = styled(Box)`
  background: linear-gradient(
    90deg,
    #0000 98%,
    ${({ theme }) => theme.colors.navy} 98%
  );
  background-size: 52%;
  min-width: 60px;
  padding-top: 28px;
  width: 60px;

  @media (max-width: ${(props) => props.theme.breaks.small}) {
    display: none;
  }
`;

export { MomentsList };
